import BaseReportPDFSettingsPreview from "../BaseReportPDFSettingsPreview";
import OvertimeReportStore from './OvertimeReportStore'

export default class PDFSettingsPreview extends BaseReportPDFSettingsPreview {
    constructor($containerEl, lightboxId, eventNamespace) {
        super($containerEl, lightboxId);
        this.eventNamespace = eventNamespace;
    }

    getStore() {
        return OvertimeReportStore;
    }

}


// WEBPACK FOOTER //
// ./web/js/reports/overtimeReport/PDFSettingsPreview.js